import {MenuItem} from "@mui/material";
import React from "react";

const enums = {
    'userRole': {
        0 : 'Client',
        1 : 'Trader',
        2 : 'Manager',
        3 : 'Admin'
    },
    'assetType': {
        0 : 'Fiat',
        1 : 'Crypto',
        2 : 'Metal'
    },
    'clientType': {
        0 : 'Private',
        1 : 'Legal'
    },
    'entityType': {
        0: 'Investment Fund',
        1: 'Hedge Fund',
        2: 'Family Office',
        3: 'Broker',
        4: 'Asset Manger',
        5: 'Service Provider',
        6: 'Charity',
        7: 'Other'
    },
    'numberOfEmployees': {
        0: '0-5',
        1: '6-25',
        2: '26-100',
        3: '101+'
    },
    'entityForm': {
        0: 'Operational',
        1: 'Domiciliary'
    },
    'companyMemberType': {
        0: 'Director',
        1: 'Shareholder',
        2: 'Representative'
    },
    'transferType': {
        0: 'Crypto',
        1: 'Bank'
    },
    'orderType': {
        0: 'Limit',
        1: 'Market'
    },
    'orderStatus': {
        0: 'New',
        1: 'In Progress',
        2: 'Completed',
        3: 'Closed'
    },
    'orderAction': {
        0: 'Buy Crypto',
        1: 'Sell Crypto'
    },
    'reportType': {
        0: 'Active Clients',
        1: 'Balance',
        2: 'Asset Movements',
        3: 'Trades',
        4: 'Trade Confirmation',
        5: 'Deposit Withdrawal Confirmation'
    },
    'reportClientData': {
        0: 'Name',
        1: 'Dossier'
    },
    'fileType': {
        0: 'Other',

        1: 'Proof Of Identity',
        2: 'Proof Of Address',
        3: 'Cv',
        4: 'Source Of Funds',

        5: 'Business Register',
        6: 'Certificate Of Incumbency',
        7: 'Aoa Memorandum',
        8: 'Organizational Chart',
        9: 'Register Of Directors',
        10: 'Register Of Shareholders',
        11: 'Financial Report',
        12: 'Power Of Attorney',
        13: 'Proof Of Office Expenses',
        14: 'Proof Of Employees Expenses',
    },
    'brokerageAgreementType': {
        0: 'OTC Brokerage',
        1: 'Precious Metal'
    },
    'ticketType': {
        0: 'Technical Issue',
        1: 'Transaction Issue',
        2: 'Trading Issue',
        3: 'Account Issue',
        4: 'Compliance Issue',
        5: 'Fee Issue',
        6: 'Security Issue',
        7: 'Feedback',
        8: 'Customer Support',
        9: 'Data Update'
    },
    'ticketSubtype': {
        0: 'Details',
        1: 'Limit',
        2: 'Wallet',
        3: 'Account',
        4: 'Deposit',
        5: 'Withdrawal'
    },
    'ticketStatus': {
        0: 'Open',
        1: 'Replied',
        2: 'Pending',
        3: 'Solved',
        4: 'Closed'
    },
    'internalNotificationType': {
        0: 'Pep Hit',
        1: 'Ticket Created',
        2: 'Ticket Updated',
        3: 'Chainalysis Alert'
    },
    'internalNotificationState': {
        0: 'Unread',
        1: 'Read'
    },
    'chainalysisNetwork': {
        0: 'Algorand',
        1: 'Arbitrum',
        2: 'Avalanche',
        3: 'Binance_Smart_Chain',
        4: 'Bitcoin',
        5: 'Bitcoin_Cash',
        6: 'Celo',
        7: 'Cronos',
        8: 'Dash',
        9: 'Dogecoin',
        10: 'EOS',
        11: 'Ethereum',
        12: 'Ethereum_Classic',
        13: 'Fantom',
        14: 'Lightning',
        15: 'Litecoin',
        16: 'Omni',
        17: 'Optimism',
        18: 'Palm',
        19: 'Polygon',
        20: 'Solana',
        21: 'Tron',
        22: 'XRP',
        23: 'Zcash'
    },
}

export function GetEnumValues(enumName) {
    return enums[enumName];
}

export function GetEnumValueName(enumName, id) {
    let enumElems = enums[enumName];

    if (!enumElems) {
        return 'Undefined';
    }

    let value = enumElems[id];

    if (!value) {
        return '-';
    }

    return value;
}

export function GetEnumMenuItems(name, includeAllButton = false) {
    let enumElems = enums[name];

    if (enumElems) {
        let items = [];

        if (includeAllButton) {
            items.push(<MenuItem key="" value="">All</MenuItem>);
        }

        for (const [key, value] of Object.entries(enumElems)) {
            let intKey = parseInt(key);
            items.push(
                <MenuItem key={intKey} value={intKey}>
                    {value}
                </MenuItem>
            );
        }
        return items;
    }
}
export function GetFileTypeMenuItems(clientType) {
    let name = 'fileType';
    let enumElems = enums[name];

    if (enumElems) {
        let items = [];

        for (const [key, value] of Object.entries(enumElems)) {
            let intKey = parseInt(key);

            if (clientType === 0 && intKey <= 4) {
                items.push(
                    <MenuItem key={intKey} value={intKey}>
                        {value}
                    </MenuItem>
                );
            } else if (clientType === 1 && (intKey === 0 || intKey >= 5)){
                items.push(
                    <MenuItem key={intKey} value={intKey}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }
}